const AgentActionTypes = {
    GET_AGENT: 'GET_AGENT',
    SET_AGENT: 'SET_AGENT',
    UPDATE_AGENT: 'UPDATE_AGENT',
    GET_SETTING: 'GET_SETTING',
    SET_SETTING: 'SET_SETTING',
    GET_FS_SETTING: 'GET_FS_SETTING',
    UPDATE_FS_SETTING: 'UPDATE_FS_SETTING',
    GET_QUICK_REACTION: 'GET_QUICK_REACTION',
    UPDATE_QUICK_REACTION: 'UPDATE_QUICK_REACTION',
    GET_VARIABLE: 'GET_VARIABLE',
    UPDATE_VARIABLE: 'UPDATE_VARIABLE',
    GET_DICTIONARY: 'GET_DICTIONARY',
    UPDATE_DICTIONARY: 'UPDATE_DICTIONARY',
    GET_FALLBACK: 'GET_FALLBACK',
    UPDATE_FALLBACK: 'UPDATE_FALLBACK',
    GET_INIT_CARDS: 'GET_INIT_CARDS',
    UPDATE_INIT_CARDS: 'UPDATE_INIT_CARDS',
    GET_END_CARDS: 'GET_END_CARDS',
    UPDATE_END_CARDS: 'UPDATE_END_CARDS',
    GET_INTERRUPT: 'GET_INTERRUPT',
    UPDATE_INTERRUPT: 'UPDATE_INTERRUPT',
}

export default AgentActionTypes
